import React, { useEffect, useState } from 'react';

const DebugPage = ({ pageName, title }) => {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadHtmlContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/${pageName}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const html = await response.text();
        setHtmlContent(html);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadHtmlContent();
  }, [pageName]);

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Cargando {title}...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h2>Error cargando {title}</h2>
        <p>{error}</p>
        <button onClick={() => window.open(`/${pageName}`, '_blank')}>
          Abrir en nueva pestaña
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '20px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
        <h1>{title}</h1>
        <p>Esta página está siendo renderizada por React. Para acceder al archivo HTML original:</p>
        <button 
          onClick={() => window.open(`/${pageName}`, '_blank')}
          style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Abrir en nueva pestaña
        </button>
        <button 
          onClick={() => window.location.href = `/${pageName}`}
          style={{
            background: '#28a745',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Abrir directamente
        </button>
      </div>
      
      <div 
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{ 
          border: '1px solid #ddd', 
          borderRadius: '5px', 
          padding: '20px',
          backgroundColor: '#f9f9f9'
        }}
      />
    </div>
  );
};

export const DebugAuthPage = () => (
  <DebugPage 
    pageName="debug_auth.html" 
    title="Debug Autenticación - IntegraMente" 
  />
);

export const TestXamppBackendPage = () => (
  <DebugPage 
    pageName="test_xampp_backend.html" 
    title="Test XAMPP Backend - IntegraMente" 
  />
);

export const TestAuthEndpointPage = () => (
  <DebugPage 
    pageName="test_auth_endpoint.html" 
    title="Test Auth Endpoint - IntegraMente" 
  />
); 

